

import React from 'react';

const formatNum = (value, decimals = 3) => {
  const num = Number(value);
  return isNaN(num) ? (0).toFixed(decimals) : num.toFixed(decimals);
};

// FORMAT TANGGAL DD-MM-YYYY
const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  const d = String(date.getDate()).padStart(2, '0');
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const y = date.getFullYear();
  return `${d}-${m}-${y}`; 
};

// FORMAT TANGGAL TTD MENGGUNAKAN NAMA BULAN
const formatTtdDate = (dateStr) => {
   if (!dateStr) return '-';
   const d = new Date(dateStr);
   const months = ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
   return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
};

const formatUnitKerja = (uk) => {
  if (!uk) return '-';
  if (uk.toLowerCase().includes('suku dinas pendidikan')) return uk.toUpperCase();
  return `${uk} - SUKU DINAS PENDIDIKAN WILAYAH II JAKARTA TIMUR`.toUpperCase();
};

// ==========================================
// DATA MAPPING TARGET KENAIKAN
// ==========================================
const TARGET_MAP = {
  'III/a': { jenjang: 'AHLI PERTAMA', pangkat: 'PENATA MUDA TK. I / III/B' },
  'III/b': { jenjang: 'AHLI MUDA', pangkat: 'PENATA / III/C' },
  'III/c': { jenjang: 'AHLI MUDA', pangkat: 'PENATA MUDA TK. I / III/D' },
  'III/d': { jenjang: 'AHLI MADYA', pangkat: 'PEMBINA / IV/A' },
  'IV/a': { jenjang: 'AHLI MADYA', pangkat: 'PEMBINA TK. I / IV/B' },
  'IV/b': { jenjang: 'AHLI MADYA', pangkat: 'PEMBINA UTAMA MUDA / IV/C' },
  'IV/c': { jenjang: 'AHLI UTAMA', pangkat: 'PEMBINA UTAMA MADYA / IV/D' },
  'IV/d': { jenjang: 'AHLI UTAMA', pangkat: 'PEMBINA UTAMA / IV/E' },
};

const TabelPreviewPAK = ({ indexId, calculation, selectedItem, nomorSurat, isDraft, forPrint, tanggalTtd, showTte = true }) => {  
  if (!calculation || !selectedItem) return null;
  const ttdDateStr = tanggalTtd || new Date().toISOString();
  const shouldShowTte = !isDraft && showTte;
  
  // LOGIKA STATUS (REAL-TIME MATH)
  const isTidakCukup = calculation.calcAutoStatusAk === 'Tidak Cukup';
  const target = TARGET_MAP[selectedItem.golongan];
  
  let textRekomendasi = "";
  if (target) {
    const statusPrefix = isTidakCukup ? "TIDAK DAPAT" : "DAPAT";
    
    // LOGIKA DINAMIS JABATAN
    let namaJabatan = "GURU";
    const jabLower = String(selectedItem.jabatan || '').toLowerCase();
    if (jabLower.includes("pengawas")) namaJabatan = "PENGAWAS SEKOLAH";
    else if (jabLower.includes("penilik")) namaJabatan = "PENILIK";
    else if (jabLower.includes("pamo") || jabLower.includes("pamong")) namaJabatan = "PAMONG BELAJAR";

    textRekomendasi = `${statusPrefix} DIPERTIMBANGKAN UNTUK KENAIKAN PANGKAT/JENJANG JABATAN SETINGKAT LEBIH TINGGI MENJADI ${namaJabatan} JENJANG ${target.jenjang} PANGKAT/GOLONGAN RUANG ${target.pangkat}`;
  } else {
    textRekomendasi = "-";
  }

  // PERBAIKAN: KOP SURAT MENGGUNAKAN TABEL 3 KOLOM AGAR CENTER SEMPURNA & AMAN DI PDF
  const KopSurat = () => (
    <div style={{ width: '100%', marginBottom: '10px', position: 'relative', zIndex: 10 }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <tbody>
          <tr>
            {/* KOLOM KIRI (LOGO) - Fix width */}
            <td style={{ width: '100px', verticalAlign: 'top', textAlign: 'left' }}>
              <img src="/logo-dki.png" alt="Logo" width="85" height="85" style={{ objectFit: 'contain', marginTop: '2px' }} />
            </td>
            
            {/* KOLOM TENGAH (TEKS) - Akan center di tengah halaman karena diapit 2 kolom 100px */}
            <td style={{ textAlign: 'center', verticalAlign: 'top', fontFamily: "'Times New Roman', Times, serif" }}>
              <div style={{ fontWeight: 'bold', fontSize: '15px', lineHeight: '1.15' }}>PEMERINTAH PROVINSI DAERAH KHUSUS IBUKOTA JAKARTA</div>
              <div style={{ fontWeight: 'bold', fontSize: '15px', lineHeight: '1.15' }}>DINAS PENDIDIKAN</div>
              <div style={{ fontWeight: 'bold', fontSize: '17px', lineHeight: '1.15', marginTop: '2px' }}>SUKU DINAS PENDIDIKAN WILAYAH II</div>
              <div style={{ fontWeight: 'bold', fontSize: '17px', lineHeight: '1.15' }}>KOTA ADMINISTRASI JAKARTA TIMUR</div>
              <div style={{ fontSize: '11px', fontWeight: 'normal', marginTop: '4px' }}>Jalan Dr. Sumarno Blok D Lt.4 Telp. (021) 4802054-4802064, Fax (021) 4802053</div>
              <div style={{ fontSize: '11px', fontWeight: 'normal', marginTop: '2px', position: 'relative' }}>
                <span style={{ letterSpacing: '0.3em' }}>JAKARTA</span>
                <span style={{ position: 'absolute', right: -100 }}>Kode Pos : 13950</span>
              </div>
            </td>

            {/* KOLOM KANAN (KOSONG PENYEIMBANG) - Fix width */}
            <td style={{ width: '100px' }}></td>
          </tr>
        </tbody>
      </table>
      <div style={{ width: '100%', borderBottom: '3px solid black', marginTop: '6px' }}></div>
    </div>
  );

  const VisualTTEImage = () => (
    <div
      style={{
        marginTop: '0px',
        width: '66mm',
        maxWidth: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        overflow: 'visible',
        pageBreakInside: 'avoid',
        breakInside: 'avoid',
        flexShrink: 0
      }}
    >
      <img
        src="/tte/tte-horale.png"
        alt="Tanda Tangan Elektronik Pejabat"
        loading="eager"
        decoding="sync"
        style={{
          display: 'block',
          width: '100%',
          height: 'auto',
          objectFit: 'contain',
          objectPosition: 'left top',
          flexShrink: 0
        }}
      />
    </div>
  );

  const TandaTangan = ({ isHalaman1 = false }) => (
    <div
      style={{
        display: 'flex',
        width: '100%',
        marginTop: isHalaman1 ? '2px' : '8px',
        color: '#000',
        fontFamily: 'Arial, Helvetica, sans-serif',
        fontSize: isHalaman1 ? '11px' : '12px',
        lineHeight: isHalaman1 ? '1.18' : '1.3',
        position: 'relative',
        zIndex: 10,
        flexShrink: 0,
        pageBreakInside: 'avoid',
        breakInside: 'avoid',
        overflow: 'visible'
      }}
    >
      {/* KOLOM KIRI */}
      <div
        style={{
          width: '50%',
          paddingRight: '10px',
          boxSizing: 'border-box',
          overflow: 'visible'
        }}
      >
        {isHalaman1 && (
          <>
            <div>
              <strong>ASLI</strong> Penetapan Angka Kredit untuk :
            </div>
            <div>Jabatan Fungsional yang bersangkutan</div>
          </>
        )}

        <div
          style={{
            marginTop: isHalaman1 ? '7px' : '0px',
            marginBottom: '3px'
          }}
        >
          Tembusan disampaikan kepada :
        </div>

        <div
          style={{
            paddingLeft: '8px',
            lineHeight: isHalaman1 ? '1.25' : '1.4'
          }}
        >
          <div>1. Pimpinan Instansi Pengusul;</div>
          <div>2. Pejabat Penilai Kinerja;</div>
          <div>3. Sekretaris Tim Penilai Kinerja; dan</div>
          <div>4. Kepala BKD Provinsi DKI Jakarta</div>
        </div>
      </div>

      {/* KOLOM KANAN */}
      <div
        style={{
          width: '50%',
          paddingLeft: '10px',
          boxSizing: 'border-box',
          overflow: 'visible'
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: isHalaman1
              ? '82px 8px 1fr'
              : '90px 10px 1fr',
            rowGap: '1px',
            overflow: 'visible'
          }}
        >
          <div>Ditetapkan di</div>
          <div>:</div>
          <div>Jakarta</div>

          <div>Pada Tanggal</div>
          <div>:</div>
          <div>{formatTtdDate(ttdDateStr)}</div>
        </div>

        {/* LABEL DIBERI RUANG SENDIRI AGAR TIDAK TERTIMPA GAMBAR */}
        <div
          style={{
            marginTop: isHalaman1 ? '5px' : '9px',
            marginBottom: isHalaman1 ? '6px' : '7px',
            minHeight: isHalaman1 ? '15px' : '17px',
            lineHeight: isHalaman1 ? '15px' : '17px',
            display: 'block',
            position: 'relative',
            zIndex: 20,
            overflow: 'visible',
            whiteSpace: 'nowrap'
          }}
        >
          Pejabat Penilai Kinerja
        </div>

        <div
          style={{
            position: 'relative',
            zIndex: 10,
            overflow: 'visible'
          }}
        >
          {shouldShowTte && <VisualTTEImage  />}
        </div>
      </div>
    </div>
  );

  const BsreFooter = () => (
    <div
      style={{
        width: '100%',
        marginTop: 'auto',
        paddingTop: '4px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        color: '#111',
        fontFamily: 'Arial, Helvetica, sans-serif',
        position: 'relative',
        zIndex: 10,
        flexShrink: 0,
        boxSizing: 'border-box'
      }}
    >
      <img
        src="/tte/logo-bsre.png"
        alt="Balai Sertifikasi Elektronik"
        loading="eager"
        decoding="sync"
        style={{
          display: 'block',
          width: '18mm',
          height: 'auto',
          objectFit: 'contain',
          flexShrink: 0
        }}
      />

      <div style={{ flex: 1, fontSize: '7.5px', lineHeight: '1.2', color: '#222' }}>
        <span style={{ fontWeight: '700' }}>Catatan: </span>
        <span>
          1. UU ITE No. 11 Tahun 2008 Pasal 5 Ayat 1: Informasi Elektronik dan/atau Dokumen Elektronik dan/atau hasil cetaknya merupakan alat bukti yang sah.
        </span>
        <span style={{ marginLeft: '4px' }}>
          2. Dokumen ini telah ditandatangani secara elektronik menggunakan sertifikat elektronik yang diterbitkan oleh BSrE BSSN.
        </span>
      </div>
    </div>
  );

  const WatermarkDraft = () => {
    if (!isDraft) return null;
    return (
      <div className="absolute inset-0 z-0 pointer-events-none flex items-center justify-center overflow-hidden">
        <div className="text-red-500/20 font-black text-[120px] -rotate-45 uppercase tracking-widest border-[8px] border-red-500/20 p-8 rounded-3xl">DRAFT</div>
      </div>
    );
  };

  const golInfo = calculation.golInfo;

  return (
    <div className={`teacher-doc-${indexId || 0} relative`} style={{ fontFamily: 'Arial, Helvetica, sans-serif' }}>
      
      {/* HALAMAN 1 
    {(!forPrint || calculation?.statusAk !== 'Tidak Cukup') && (
        // PERBAIKAN: Padding bottom pb-[10mm] jadi pb-[15mm] agar batas bawah kertas lebih luas
        */}
        <div className="pdf-page bg-white w-[210mm] h-[297mm] pt-[9mm] pb-[3mm] px-[15mm] box-border relative overflow-hidden text-black">
          <WatermarkDraft />
          <KopSurat />

          <div className="relative z-10 text-center font-bold text-sm mb-3">
            <div>PENETAPAN ANGKA KREDIT</div>
            <div>NOMOR: {nomorSurat}</div>
          </div>
          
          <div className="relative z-10 flex justify-between mb-1 text-[11px]">
            <div>Instansi : DINAS PENDIDIKAN PROVINSI DKI JAKARTA</div>
            <div>Masa Penilaian : {calculation.periodeCetak}</div>
          </div>

          <table className="relative z-10 w-full border-collapse border border-black mb-1 text-[11px] table-fixed">
            <colgroup>
              <col style={{ width: '4%' }} />
              <col style={{ width: '4%' }} />
              <col style={{ width: '38%' }} />
              <col style={{ width: '12%' }} />
              <col style={{ width: '12%' }} />
              <col style={{ width: '12%' }} />
              <col style={{ width: '18%' }} />
            </colgroup>
            <tbody>
              <tr>
                <td className="border border-black p-1 text-center font-bold">I</td>
                <td colSpan="6" className="border border-black p-1 px-1.5 font-bold">KETERANGAN PERORANGAN</td>
              </tr>
              {[
                ['1', 'Nama', selectedItem.full_name],
                ['2', 'NIP', selectedItem.nip],
                ['3', 'Nomor Seri Karpeg', selectedItem.karpeg || '-'],
                ['4', 'Tempat/Tanggal lahir', `${selectedItem.tempat_lahir || '-'}, ${formatDate(selectedItem.tanggal_lahir)}`],
                ['5', 'Jenis Kelamin', selectedItem.jenis_kelamin],
                ['6', 'Pangkat/Golongan Ruang /TMT', `${selectedItem.pangkat} / ${selectedItem.golongan} / ${formatDate(selectedItem.tmt_golongan)}`],
                ['7', 'Jabatan/TMT', `${selectedItem.jabatan} / ${formatDate(selectedItem.tmt_jabatan)}`],
                ['8', 'Unit Kerja', formatUnitKerja(selectedItem.unit_kerja)]
              ].map((row, i) => (
                <tr key={i}>
                  <td className="border border-black p-1"></td>
                  <td className="border border-black p-1 text-center align-top">{row[0]}</td>
                  <td className="border border-black p-1 px-1.5 align-top">{row[1]}</td>
                  <td colSpan="4" className="border border-black p-1 px-1.5 align-top uppercase">{row[2]}</td>
                </tr>
              ))}

              <tr className="bg-gray-50/80 font-bold text-center">
                <td colSpan="7" className="border border-black p-1.5 uppercase">HASIL PENILAIAN ANGKA KREDIT</td>
              </tr>

              <tr className="bg-gray-50/80 font-bold text-center">
                <td className="border border-black p-1 align-middle">II</td>
                <td colSpan="2" className="border border-black p-1 align-middle">PENETAPAN ANGKA KREDIT</td>
                <td className="border border-black p-1 align-middle">LAMA</td>
                <td className="border border-black p-1 align-middle">BARU</td>
                <td className="border border-black p-1 align-middle">JUMLAH</td>
                <td className="border border-black p-1 align-middle">KETERANGAN</td>
              </tr>
              <tr className="bg-gray-50/80 text-center font-normal">
                <td className="border border-black p-0.5">1</td><td colSpan="2" className="border border-black p-0.5">2</td>
                <td className="border border-black p-0.5">3</td><td className="border border-black p-0.5">4</td>
                <td className="border border-black p-0.5">5</td><td className="border border-black p-0.5">6</td>
              </tr>

              <tr>
                <td className="border border-black p-1 text-center align-top">1</td>
                <td colSpan="2" className="border border-black p-1 px-1.5 align-top">AK Dasar yang diberikan</td>
                <td className="border border-black p-1 text-center align-top"></td>
                <td className="border border-black p-1 text-center align-top"></td>
                <td className="border border-black p-1 text-center align-top"></td>
                <td className="border border-black p-1 align-top"></td>
              </tr>
              <tr>
                <td className="border border-black p-1 text-center align-top">2</td>
                <td colSpan="2" className="border border-black p-1 px-1.5 align-top">AK JF lama</td>
                <td className="border border-black p-1 text-center align-top"></td>
                <td className="border border-black p-1 text-center align-top"></td>
                <td className="border border-black p-1 text-center align-top"></td>
                <td className="border border-black p-1 align-top"></td>
              </tr>
              <tr>
                <td className="border border-black p-1 text-center align-top">3</td>
                <td colSpan="2" className="border border-black p-1 px-1.5 align-top">AK Penyesuaian/Penyetaraan</td>
                <td className="border border-black p-1 text-center align-top"></td>
                <td className="border border-black p-1 text-center align-top"></td>
                <td className="border border-black p-1 text-center align-top"></td>
                <td className="border border-black p-1 align-top"></td>
              </tr>
              <tr>
                <td className="border border-black p-1 text-center align-top">4</td>
                <td colSpan="2" className="border border-black p-1 px-1.5 align-top">AK Konversi</td>
                <td className="border border-black p-1 text-center align-top">{selectedItem.ak_lama > 0 && calculation.akKonversiLama > 0 ? formatNum(calculation.akKonversiLama) : ''}</td>
                <td className="border border-black p-1 text-center align-top">{formatNum(calculation.akKonversiBaru)}</td>
                <td className="border border-black p-1 text-center align-top font-bold">{formatNum(calculation.totalKonversi)}</td>
                <td className="border border-black p-1 align-top"></td>
              </tr>
              <tr>
                <td className="border border-black p-1 text-center align-top">5</td>
                <td colSpan="2" className="border border-black p-1 px-1.5 align-top">AK yang diperoleh dari peningkatan pendidikan</td>
                <td className="border border-black p-1 text-center align-top"></td>
                <td className="border border-black p-1 text-center align-top">{calculation.akPG > 0 ? formatNum(calculation.akPG) : ''}</td>
                <td className="border border-black p-1 text-center align-top">{calculation.akPG > 0 ? formatNum(calculation.akPG) : ''}</td>
                <td className="border border-black p-1 align-top"></td>
              </tr>
              <tr>
                <td className="border border-black p-1 text-center align-top">6</td>
                <td colSpan="2" className="border border-black p-1 px-1.5 align-top">......... **)</td>
                <td className="border border-black p-1 text-center align-top"></td>
                <td className="border border-black p-1 text-center align-top"></td>
                <td className="border border-black p-1 text-center align-top"></td>
                <td className="border border-black p-1 align-top"></td>
              </tr>

              <tr className="font-bold uppercase bg-gray-50/80">
                <td colSpan="3" className="border border-black p-1.5 text-center align-middle">JUMLAH ANGKA KREDIT KUMULATIF</td>
                <td className="border border-black p-1.5 text-center align-middle">{selectedItem.ak_lama > 0 && calculation.akKonversiLama > 0 ? formatNum(calculation.akKonversiLama) : ''}</td>
                <td className="border border-black p-1.5 text-center align-middle">{formatNum(calculation.akKonversiBaru + calculation.akPG)}</td>
                <td className="border border-black p-1.5 text-center align-middle">{formatNum(calculation.totalKumulatif)}</td>
                <td className="border border-black p-1.5 align-middle"></td>
              </tr>

              <tr className="font-bold bg-gray-50/80 text-center">
                <td colSpan="3" className="border border-black p-1 align-middle">Keterangan</td>
                <td colSpan="2" className="border border-black p-1 align-middle">Pangkat</td>
                <td colSpan="2" className="border border-black p-1 align-middle">Jenjang Jabatan</td>
              </tr>
              <tr>
                <td colSpan="3" className="border border-black p-1 px-1.5 align-top">Angka Kredit Minimal yang harus dipenuhi untuk kenaikan pangkat/jenjang</td>
                <td colSpan="2" className="border border-black p-1 text-center align-middle">{golInfo.akLama}</td>
                <td colSpan="2" className="border border-black p-1 text-center align-middle">{golInfo.jenjang === -1 ? '-' : golInfo.jenjang}</td>
              </tr>
              
              <tr>
                <td colSpan="3" className="border border-black p-1 px-1.5 align-top">
                  {calculation.sisaPangkat >= 0 ? 'Kelebihan' : 'Kekurangan'} Angka Kredit yang harus dicapai untuk kenaikan pangkat
                </td>
                
                {/* KOLOM PANGKAT (Selalu berada di atas/top) */}
                <td colSpan="2" rowSpan="2" className="border border-black p-1 text-center" style={{ verticalAlign: 'top', paddingTop: '4px' }}>
                   {formatNum(calculation.sisaPangkat)}
                </td>
                
                {/* KOLOM JENJANG JABATAN (Selalu berada di bawah/bottom) */}
                <td colSpan="2" rowSpan="2" className="border border-black p-1 text-center" style={{ verticalAlign: golInfo.jenjang === -1 ? 'middle' : 'bottom', paddingBottom: '4px' }}>
                  {golInfo.jenjang === -1 ? '-' : formatNum(calculation.sisaJenjang)}
                </td>
              </tr>
              
              <tr>
                <td colSpan="3" className="border border-black p-1 px-1.5 align-top">
                  {calculation.sisaJenjang >= 0 ? 'Kelebihan' : 'Kekurangan'} Angka Kredit yang harus dicapai untuk kenaikan Jenjang
                </td>
              </tr>

              <tr className="font-bold bg-gray-50/80">
                <td colSpan="7" className="border border-black p-2.5 uppercase text-[11px] text-left align-middle leading-tight">
                  {textRekomendasi}
                </td>
              </tr>
            </tbody>
          </table>
          <TandaTangan isHalaman1={true} />
        </div>
     {/*
      )}
      */}

      {/* HALAMAN 2: AKUMULASI 
      {(!forPrint || calculation?.statusAk !== 'Tidak Cukup') && (
      // PERBAIKAN: Padding bottom pb-[10mm] jadi pb-[15mm] agar batas bawah kertas lebih luas
        */}
        <div className="pdf-page bg-white w-[210mm] h-[297mm] pt-[10mm] pb-[7mm] px-[15mm] box-border relative overflow-hidden mt-4 text-black flex flex-col">
          <WatermarkDraft />
          <KopSurat />
          
          <div className="relative z-10 text-center font-bold text-sm mb-4">
            <div>AKUMULASI ANGKA KREDIT</div>
            <div>NOMOR: {nomorSurat}</div>
          </div>
          <div className="relative z-10 flex justify-between mb-2 text-[11px]">
            <div>Instansi : DINAS PENDIDIKAN PROVINSI DKI JAKARTA</div>
            <div>Periode : {calculation.periodeCetak}</div>
          </div>
          
          <div className="relative z-10 w-full text-[11px]">
            <div className="border-t border-x border-black">
              <div className="text-center border-b border-black p-1 align-middle uppercase font-normal">JABATAN FUNGSIONAL YANG DINILAI</div>
              <div className="flex flex-col font-normal">
                {[
                  ['Nama', selectedItem.full_name], ['NIP', selectedItem.nip], ['Nomor Seri Karpeg', selectedItem.karpeg || '-'],
                  ['Tempat/Tanggal lahir', `${selectedItem.tempat_lahir || '-'}, ${formatDate(selectedItem.tanggal_lahir)}`],
                  ['Jenis Kelamin', selectedItem.jenis_kelamin], ['Pangkat/Golongan Ruang /TMT', `${selectedItem.pangkat}, ${selectedItem.golongan}, ${formatDate(selectedItem.tmt_golongan)}`],
                  ['Jabatan/TMT', `${selectedItem.jabatan} / ${formatDate(selectedItem.tmt_jabatan)}`],
                  ['Unit Kerja', formatUnitKerja(selectedItem.unit_kerja)], 
                  ['Instansi', 'DINAS PENDIDIKAN PROVINSI DKI JAKARTA']
                ].map((row, i) => (
                  <div key={i} className="grid grid-cols-[1fr_auto_2fr] border-b border-black">
                    <div className="p-1.5 px-2 align-top">{row[0]}</div>
                    <div className="p-1.5 text-center align-top">:</div>
                    <div className="p-1.5 uppercase align-top">{row[1]}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="relative z-10 w-full text-[11px]">
             <div className="text-center py-1 uppercase font-bold border-t border-x border-black">KONVERSI PREDIKAT KINERJA KE ANGKA KREDIT</div>
             
             <table className="relative z-10 w-full border-collapse border border-black mb-8 table-fixed">
                <thead>
                   <tr className="text-center font-normal">
                      <th colSpan="4" className="border border-black p-1 align-middle">HASIL PENILAIAN KINERJA</th>
                      <th rowSpan="2" className="border border-black p-1 align-middle whitespace-nowrap">KOEFISIEN PER<br/>TAHUN</th>
                      <th rowSpan="2" className="border border-black p-1 align-middle whitespace-nowrap">ANGKA KREDIT<br/>YANG DIDAPAT</th>
                   </tr>
                   <tr className="text-center font-normal">
                      <th className="border border-black p-1 align-middle">TAHUN</th>
                      <th className="border border-black p-1 align-middle">PERIODIK (BULAN)</th>
                      <th className="border border-black p-1 align-middle">PREDIKAT</th>
                      <th className="border border-black p-1 align-middle">PROSENTASE</th>
                   </tr>
                   <tr className="text-center font-normal">
                      <td className="border border-black p-0.5">1</td>
                      <td className="border border-black p-0.5">2</td>
                      <td className="border border-black p-0.5">3</td>
                      <td className="border border-black p-0.5">4</td>
                      <td className="border border-black p-0.5">5</td>
                      <td className="border border-black p-0.5">6</td>
                   </tr>
                </thead>
                <tbody className="font-normal">
                   <tr className="text-center">
                      <td className="border border-black p-1 align-middle">{calculation.tahunBaseAK}</td>
                      <td className="border border-black p-1 align-middle">{calculation.labelJenisPak}</td>
                      <td className="border border-black p-1 align-middle"></td>
                      <td className="border border-black p-1 align-middle"></td>
                      <td className="border border-black p-1 align-middle"></td>
                      <td className="border border-black p-1 align-middle">{formatNum(calculation.sisaAKLama)}</td>
                   </tr>
                {calculation.detailSKP.filter(row => row.bulan > 0).map((row, idx) => (
                      <tr key={idx} className="text-center">
                         <td className="border border-black p-1 align-middle">{row.tahun}</td>
                         <td className="border border-black p-1 align-middle">{row.periode}</td>                         <td className="border border-black p-1 align-middle">{row.predikat}</td>
                         <td className="border border-black p-1 align-middle">{row.prosentaseStr}</td>
                         <td className="border border-black p-1 align-middle">{formatNum(row.koef, 2)}</td>
                         <td className="border border-black p-1 align-middle">{formatNum(row.result)}</td>
                      </tr>
                   ))}
                   
                   {calculation.akPG > 0 && (
                      <tr className="text-center">
                         <td className="border border-black p-1 align-middle">{selectedItem.tahun_usulan_gelar || '-'}</td>
                         <td className="border border-black p-1 align-middle">Angka Kredit Peningkatan Pendidikan</td>
                         <td className="border border-black p-1 align-middle"></td>
                         <td className="border border-black p-1 align-middle"></td>
                         <td className="border border-black p-1 align-middle"></td>
                         <td className="border border-black p-1 align-middle">{formatNum(calculation.akPG)}</td>
                      </tr>
                   )}
                   <tr className="uppercase text-center font-normal">
                      <td colSpan="5" className="border border-black p-1.5 align-middle">JUMLAH ANGKA KREDIT YANG DIPEROLEH</td>
                      <td className="border border-black p-1.5 align-middle">{formatNum(calculation.jumlahAkDiperoleh)}</td>
                   </tr>
                 </tbody>
             </table>
          </div>
          <TandaTangan />
          {shouldShowTte && <BsreFooter />}
        </div>
     {/*
      )}
      */}


      {/* HALAMAN 3 (SKP KONVERSI) */}
 {calculation.detailSKP
        .filter(skpData => skpData.bulan > 0)
        .map((skpData, index) => (
        <div key={`hal3-${index}`} className="pdf-page bg-white w-[210mm] h-[297mm] pt-[10mm] pb-[7mm] px-[15mm] box-border relative overflow-hidden mt-4 text-black flex flex-col">          <WatermarkDraft />
          <KopSurat />
          
          <div className="relative z-10 text-center font-bold text-sm mb-4 uppercase">
             <div>KONVERSI PREDIKAT KINERJA KE ANGKA KREDIT</div>
             <div>NOMOR: {nomorSurat}</div>
          </div>
          
          <div className="relative z-10 flex justify-between mb-1 text-[11px]">
            <div>Instansi : DINAS PENDIDIKAN PROVINSI DKI JAKARTA</div>
            <div>Periode : {skpData.periode} {skpData.tahun}</div>
          </div>

          <div className="relative z-10 w-full text-[11px]">
            <div className="border-t border-x border-black">
              <div className="text-center border-b border-black p-1 uppercase font-normal">JABATAN FUNGSIONAL YANG DINILAI</div>
              <div className="flex flex-col font-normal">
                {[
                  ['Nama', selectedItem.full_name], ['NIP', selectedItem.nip], ['Nomor Seri Karpeg', selectedItem.karpeg || '-'],
                  ['Tempat/Tanggal lahir', `${selectedItem.tempat_lahir || '-'}, ${formatDate(selectedItem.tanggal_lahir)}`],
                  ['Jenis Kelamin', selectedItem.jenis_kelamin], ['Pangkat/Golongan Ruang /TMT', `${selectedItem.pangkat}, ${selectedItem.golongan}, ${formatDate(selectedItem.tmt_golongan)}`],
                  ['Jabatan/TMT', `${selectedItem.jabatan} / ${formatDate(selectedItem.tmt_jabatan)}`],
                  ['Unit Kerja', formatUnitKerja(selectedItem.unit_kerja)], 
                  ['Instansi', 'DINAS PENDIDIKAN PROVINSI DKI JAKARTA']
                ].map((row, i) => (
                   <div key={i} className="grid grid-cols-[1fr_auto_2fr] border-b border-black">
                    <div className="p-1.5 px-2 align-top">{row[0]}</div>
                    <div className="p-1.5 text-center align-top">:</div>
                    <div className="p-1.5 uppercase align-top">{row[1]}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="relative z-10 w-full text-[11px]">
             <div className="text-center py-1 uppercase font-bold border-t border-x border-black">KONVERSI PREDIKAT KINERJA KE ANGKA KREDIT</div>
             
             <table className="relative z-10 w-full border-collapse border border-black mb-8 table-fixed">
                <thead>
                   <tr className="text-center font-normal">
                      <th colSpan="2" className="border border-black p-1 align-middle">HASIL PENILAIAN KINERJA</th>
                      <th rowSpan="2" className="border border-black p-1 align-middle whitespace-nowrap">KOEFISIEN PER<br/>TAHUN</th>
                      <th rowSpan="2" className="border border-black p-1 align-middle whitespace-nowrap">ANGKA KREDIT<br/>YANG DIDAPAT</th>
                   </tr>
                   <tr className="text-center font-normal">
                      <th className="border border-black p-1 align-middle">PREDIKAT</th>
                      <th className="border border-black p-1 align-middle">PROSENTASE</th>
                   </tr>
                   <tr className="text-center font-normal">
                      <td className="border border-black p-0.5">1</td>
                      <td className="border border-black p-0.5">2</td>
                      <td className="border border-black p-0.5">3</td>
                      <td className="border border-black p-0.5">4</td>
                   </tr>
                </thead>
                <tbody className="font-normal">
                   <tr className="text-center">
                      <td className="border border-black p-2 align-middle">{skpData.predikat}</td>
                      <td className="border border-black p-2 align-middle">{skpData.prosentaseStr}</td>
                      <td className="border border-black p-2 align-middle">{formatNum(skpData.koef, 2)}</td>
                      <td className="border border-black p-2 align-middle">{formatNum(skpData.result)}</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <TandaTangan />
          {shouldShowTte && <BsreFooter />}
        </div>
      ))}
    </div>
  );
};

export default TabelPreviewPAK;